<div *ngIf="tipo=='dados-registro'">
  <div class="body">
    <label>Nome</label>
    <p>{{dados?.Nome?.[0]}}</p>
    <label>Código MEC</label>
    <p>{{dados?.CodigoMEC?.[0]}}</p>
    <label>CNPJ</label>
    <p>{{dados?.CNPJ?.[0]}}</p>

    <h5>Endereço do Curso</h5>
    <ng-container *ngIf="dados?.Endereco?.[0] as endereco">
      <ng-container *ngIf="endereco.Logradouro">
        <label>Logradouro</label>
        <p>{{endereco.Logradouro[0]}}</p>
      </ng-container>
      <ng-container *ngIf="endereco.Numero">
        <label>Número</label>
        <p>{{endereco.Numero[0]}}</p>
      </ng-container>
      <ng-container *ngIf="endereco.Complemento">
        <label>Complemento</label>
        <p>{{endereco.Complemento[0]}}</p>
      </ng-container>
      <label>Bairro</label>
      <p>{{endereco.Bairro?.[0]}}</p>
      <label>CEP</label>
      <p>{{endereco.CEP?.[0]}}</p>
      <label>Município</label>
      <p>{{endereco.NomeMunicipio?.[0]}}</p>
      <label>Código do Município</label>
      <p>{{endereco.CodigoMunicipio?.[0]}}</p>
      <label>UF</label>
      <p>{{endereco.UF?.[0]}}</p>
    </ng-container>

    <ng-container *ngIf="dados?.Credenciamento?.[0] as credenciamento">
      <h5>Credenciamento</h5>
      <label>Tipo</label>
      <p>{{credenciamento.Tipo?.[0]}}</p>
      <label>Número</label>
      <p>{{credenciamento.Numero?.[0]}}</p>
      <label>Data</label>
      <p>{{credenciamento.Data?.[0] | date: 'dd/MM/YYYY'}}</p>
      <label>Data de publicação</label>
      <p>{{credenciamento.DataPublicacao?.[0] | date: 'dd/MM/YYYY'}}</p>
      <label>Seção</label>
      <p>{{credenciamento.SecaoPublicacao?.[0]}}</p>
      <label>Página</label>
      <p>{{credenciamento.PaginaPublicacao?.[0]}}</p>
    </ng-container>

    <ng-container *ngIf="dados?.Recredenciamento?.[0] as recredenciamento">
      <h5>Recredenciamento</h5>
      <label>Recredenciado</label>
      <p>{{recredenciamento.Tipo?.[0]}}</p>
      <label>Número</label>
      <p>{{recredenciamento.Numero?.[0]}}</p>
      <label>Data</label>
      <p>{{recredenciamento.Data?.[0] | date: 'dd/MM/YYYY'}}</p>
      <label>Seção</label>
      <p>{{recredenciamento.SecaoPublicacao?.[0]}}</p>
      <label>Página</label>
      <p>{{recredenciamento.PaginaPublicacao?.[0]}}</p>
      <label>Data de Publicação</label>
      <p>{{recredenciamento.DataPublicacao?.[0] | date: 'dd/MM/YYYY'}}</p>
    </ng-container>

    <ng-container *ngIf="dados?.Mantenedora?.[0] as mantenedora">
      <h5>Dados da Mantenedora</h5>
      <label>Razão Social</label>
      <p>{{mantenedora.RazaoSocial?.[0]}}</p>
      <label>CNPJ</label>
      <p>{{mantenedora.CNPJ?.[0]}}</p>
      <ng-container *ngIf="mantenedora.Endereco?.[0] as endMantenedora">
        <ng-container *ngIf="endMantenedora.Logradouro">
          <label>Logradouro</label>
          <p>{{endMantenedora.Logradouro[0]}}</p>
        </ng-container>
        <ng-container *ngIf="endMantenedora.Numero">
          <label>Número</label>
          <p>{{endMantenedora.Numero[0]}}</p>
        </ng-container>
        <ng-container *ngIf="endMantenedora.Complemento">
          <label>Complemento</label>
          <p>{{endMantenedora.Complemento[0]}}</p>
        </ng-container>
        <label>Bairro</label>
        <p>{{endMantenedora.Bairro?.[0]}}</p>
        <label>CEP</label>
        <p>{{endMantenedora.CEP?.[0]}}</p>
        <label>Município</label>
        <p>{{endMantenedora.NomeMunicipio?.[0]}}</p>
        <label>Código do Município</label>
        <p>{{endMantenedora.CodigoMunicipio?.[0]}}</p>
        <label>UF</label>
        <p>{{endMantenedora.UF?.[0]}}</p>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="dados?.LivroRegistro as livro">
      <h5>Livro Registro</h5>
      <label>Livro Registro</label>
      <p>{{livro.LivroRegistro?.[0]}}</p>
      <label>Número Folha do {{ tipoCurso === 1 ? 'Certificado' : 'Diploma' }}</label>
      <p>{{livro.NumeroFolhaDoDiploma?.[0]}}</p>
      <label>Número Sequência do {{ tipoCurso === 1 ? 'Certificado' : 'Diploma' }}</label>
      <p>{{livro.NumeroSequenciaDoDiploma?.[0]}}</p>

      <ng-container *ngIf="tipoCurso !== 1">
        <label>Processo do Diploma</label>
        <p>{{livro.ProcessoDoDiploma?.[0]}}</p>
        <label>Data Colação Grau</label>
        <p>{{livro.DataColacaoGrau?.[0] | date: 'dd/MM/YYYY'}}</p>
      </ng-container>
      <label>Data de Expedição do {{ tipoCurso === 1 ? 'Certificado' : 'Diploma' }}</label>
      <p>{{livro.DataExpedicaoDiploma?.[0] | date: 'dd/MM/YYYY'}}</p>
      <label>Data de Registro do {{ tipoCurso === 1 ? 'Certificado' : 'Diploma' }}</label>
      <p>{{livro.DataRegistroDiploma?.[0] | date: 'dd/MM/YYYY'}}</p>
    </ng-container>
  </div>
</div>

<div *ngIf="tipo=='dados-curso'">
  <div class="body">
    <label>Nome do Curso</label>
    <p>{{dados?.NomeCurso?.[0]}}</p>
    <label>Código Curso EMEC</label>
    <p>{{dados?.CodigoCursoEMEC?.[0]}}</p>
    <ng-container *ngIf="dados?.NumeroHabilitacao">
      <label>Nome Habilitação</label>
      <p>{{dados?.NomeHabilitacao?.[0]}}</p>
    </ng-container>
    <label>Titulo Conferido</label>
    <p>{{dados?.TituloConferido?.[0]?.OutroTitulo?.[0]}}</p>
    <label>Grau Conferido</label>
    <p>{{dados?.GrauConferido?.[0]}}</p>

    <ng-container *ngIf="dados?.EnderecoCurso?.[0] as enderecoCurso">
      <h5>Endereço do Curso</h5>
      <ng-container *ngIf="enderecoCurso.Logradouro">
        <label>Logradouro</label>
        <p>{{enderecoCurso.Logradouro[0]}}</p>
      </ng-container>
      <label>Bairro</label>
      <p>{{enderecoCurso.Bairro?.[0]}}</p>
      <label>CEP</label>
      <p>{{enderecoCurso.CEP?.[0]}}</p>
      <label>Município</label>
      <p>{{enderecoCurso.NomeMunicipio?.[0]}}</p>
      <label>Código do Município</label>
      <p>{{enderecoCurso.CodigoMunicipio?.[0]}}</p>
      <label>UF</label>
      <p>{{enderecoCurso.UF?.[0]}}</p>
    </ng-container>

    <ng-container *ngIf="dados?.Autorizacao?.[0] as autorizacao">
      <h5>Autorização</h5>
      <label>Tipo</label>
      <p>{{autorizacao.Tipo?.[0]}}</p>
      <ng-container *ngIf="autorizacao.Numero">
        <label>Número</label>
        <p>{{autorizacao.Numero[0]}}</p>
      </ng-container>
      <ng-container *ngIf="autorizacao.Complemento">
        <label>Complemento</label>
        <p>{{autorizacao.Complemento[0]}}</p>
      </ng-container>
      <label>Data</label>
      <p>{{autorizacao.Data?.[0] | date: 'dd/MM/YYYY'}}</p>
    </ng-container>

    <ng-container *ngIf="dados?.Reconhecimento?.[0] as reconhecimento">
      <h5>Reconhecimento</h5>
      <label>Tipo</label>
      <p>{{reconhecimento.Tipo?.[0]}}</p>
      <label>Número</label>
      <p>{{reconhecimento.Numero?.[0]}}</p>
      <label>Data</label>
      <p>{{reconhecimento.Data?.[0] | date: 'dd/MM/YYYY'}}</p>
    </ng-container>

    <ng-container *ngIf="dados?.RenovacaoReconhecimento?.[0] as renovacao">
      <h5>Renovação Reconhecimento</h5>
      <label>Data</label>
      <p>{{renovacao.Data?.[0] | date: 'dd/MM/YYYY'}}</p>
      <label>Número</label>
      <p>{{renovacao.Numero?.[0]}}</p>
      <label>Tipo</label>
      <p>{{renovacao.Tipo?.[0]}}</p>
    </ng-container>
  </div>
</div>

<div *ngIf="tipo=='dados-ies'">
  <div class="body">
    <label>Nome</label>
    <p>{{dados?.Nome?.[0]}}</p>
    <label>Código MEC</label>
    <p>{{dados?.CodigoMEC?.[0]}}</p>
    <label>CNPJ</label>
    <p>{{dados?.CNPJ?.[0]}}</p>

    <ng-container *ngIf="dados?.Endereco?.[0] as endereco">
      <h5>Endereço</h5>
      <ng-container *ngIf="endereco.Logradouro">
        <label>Logradouro</label>
        <p>{{endereco.Logradouro[0]}}</p>
      </ng-container>
      <ng-container *ngIf="endereco.Numero">
        <label>Número</label>
        <p>{{endereco.Numero[0]}}</p>
      </ng-container>
      <ng-container *ngIf="endereco.Complemento">
        <label>Complemento</label>
        <p>{{endereco.Complemento[0]}}</p>
      </ng-container>
      <label>Bairro</label>
      <p>{{endereco.Bairro?.[0]}}</p>
      <label>CEP</label>
      <p>{{endereco.CEP?.[0]}}</p>
      <label>Município</label>
      <p>{{endereco.NomeMunicipio?.[0]}}</p>
      <label>Código do Município</label>
      <p>{{endereco.CodigoMunicipio?.[0]}}</p>
      <label>UF</label>
      <p>{{endereco.UF?.[0]}}</p>
    </ng-container>

    <ng-container *ngIf="dados?.Credenciamento?.[0] as credenciamento">
      <h5>Credenciamento</h5>
      <label>Tipo</label>
      <p>{{credenciamento.Tipo?.[0]}}</p>
      <label>Número</label>
      <p>{{credenciamento.Numero?.[0]}}</p>
      <label>Data</label>
      <p>{{credenciamento.Data?.[0] | date: 'dd/MM/YYYY'}}</p>
      <label>Data de publicação</label>
      <p>{{credenciamento.DataPublicacao?.[0] | date: 'dd/MM/YYYY'}}</p>
      <label>Seção</label>
      <p>{{credenciamento.SecaoPublicacao?.[0]}}</p>
      <label>Página</label>
      <p>{{credenciamento.PaginaPublicacao?.[0]}}</p>
    </ng-container>

    <ng-container *ngIf="dados?.Recredenciamento?.[0] as recredenciamento">
      <h5>Recredenciamento</h5>
      <label>Recredenciado</label>
      <p>{{recredenciamento.Tipo?.[0]}}</p>
      <label>Número</label>
      <p>{{recredenciamento.Numero?.[0]}}</p>
      <label>Data</label>
      <p>{{recredenciamento.Data?.[0] | date: 'dd/MM/YYYY'}}</p>
      <label>Seção</label>
      <p>{{recredenciamento.SecaoPublicacao?.[0]}}</p>
      <label>Página</label>
      <p>{{recredenciamento.PaginaPublicacao?.[0]}}</p>
      <label>Data de Publicação</label>
      <p>{{recredenciamento.DataPublicacao?.[0] | date: 'dd/MM/YYYY'}}</p>
    </ng-container>

    <ng-container *ngIf="dados?.Mantenedora?.[0] as mantenedora">
      <h5>Dados da Mantenedora</h5>
      <label>Razão Social</label>
      <p>{{mantenedora.RazaoSocial?.[0]}}</p>
      <label>CNPJ</label>
      <p>{{mantenedora.CNPJ?.[0]}}</p>
      <ng-container *ngIf="mantenedora.Endereco?.[0] as endMantenedora">
        <ng-container *ngIf="endMantenedora.Logradouro">
          <label>Logradouro</label>
          <p>{{endMantenedora.Logradouro[0]}}</p>
        </ng-container>
        <ng-container *ngIf="endMantenedora.Numero">
          <label>Número</label>
          <p>{{endMantenedora.Numero[0]}}</p>
        </ng-container>
        <label>Bairro</label>
        <p>{{endMantenedora.Bairro?.[0]}}</p>
        <label>CEP</label>
        <p>{{endMantenedora.CEP?.[0]}}</p>
        <label>Município</label>
        <p>{{endMantenedora.NomeMunicipio?.[0]}}</p>
        <label>Código do Município</label>
        <p>{{endMantenedora.CodigoMunicipio?.[0]}}</p>
        <label>UF</label>
        <p>{{endMantenedora.UF?.[0]}}</p>
      </ng-container>
    </ng-container>
  </div>
</div>
